const idConfiguration = {
  name: 'Modalku',
  email: 'info@modalku.co.id',
  country_code: 'ID',
  country_name: 'Indonesia',
  currency: 'IDR - Indonesia Rupiah',
  currency_code: 'IDR',
  currency_symbol: 'Rp',
  enableLoyaltyProgram: false,
  encryption_key: 'MK-ID',
  header_logo_classname_prefix: 'mk',
  header_vertical_logo_classname_prefix: 'mk',
  header_vertical_logo_path: '/assets/img/header/logo-mk.svg',
  header: {
    completeAccountActivation: {
      show: false
    },
  },
  // Temporary remove -> Search for first-deposit-message to enable again
  format: {
    date: 'y-MM-dd',
    date_time: 'y-MM-dd HH:mm:ss',
    activity_date_time: 'MMM dd y HH:mm',
    decimal: '1.2-2',
    decimal_separator: ',',
    thousands_separator: '.',
    locale: 'id'
  },
  institution_id: 11,
  language: 'id',
  supportedLanguages: ['en', 'id'],
  mobileAppUrl: {
    investor: {
      googlePlay: 'https://play.google.com/store/apps/details?id=id.co.modalku.investor',
      appStore: 'https://apps.apple.com/id/app/modalku/id1258040109'
    }
  },
  meta: {
    image: '/assets/img/icon/logo.png',
    og_type: 'information',
    twitter_card: 'summary_large_image',
    twitter_site: '@modalkuid'
  },
  browseLoan: {
    borrowerName: false,
    discussionForum: false,
    showOptOut: true,
    redirectToPayment: false,
    powerOfAttorney: true,
    riskDisclosureStatement: false,
    riskDisclosureStatementChecked: false,
    suitabilityAssessmentTest: false,
    suitabilityAssessmentTestChecked: false,
    personalParticularsDisclaimer: false,
    personalParticularsDisclaimerChecked: false,
    referSme: true,
    investmentInformation: false,
    investmentHistory: {
      showOutstandingDetail: true
    },
    blog: 'https://blog.modalku.co.id',
    fundingProgress: {
      show: false,
      successfulLimit: 100
    },
    crowdfundingTimeLeft: {
      exact: false,
      showInSuccessLoan: false
    },
    retailInvestorInvestingLimit: {
      enable: false
    },
  },
  referral: {
    vip: false
  },
  image_base_url: 'assets/img/ID',
  phone_prefix: '+62',
  help: {
    general: {
      id: 'https://intercom.help/modalku-help/id',
      en: 'https://intercom.help/modalku-help/id'
    },
    borrower: {
      id: 'https://intercom.help/modalku-help/id/collections/2692559-peminjam',
      en: 'https://intercom.help/modalku-help/id/collections/2692559-peminjam'
    },
    investor: {
      id: 'https://intercom.help/modalku-help/id/collections/623147-pendana',
      en: 'https://intercom.help/modalku-help/id/collections/623147-pendana'
    },
    show: {
      publicPage: true,
      loggedInPage: false //For submenu when user already log in
    }
  },
  va_detail: {
    VA_bank: 'Sinarmas',
    VA_bank_bca: 'Bank Central Asia',
    VA_bank_bni: 'Bank Negara Indonesia',
    VA_bank_bca_id: '12999 ',
    VA_branch: 'KCU Thamrin',
    VA_name: 'MDKU QQ',
    VA_id: '8299',
  },
  portfolio: {
    showBorrowerIdentity: {
      company: false,
      name: false
    },
    tableColumnDisplay: {
      gst: false,
      withholdingTax: true
    },
    showTaxField: false,
    columnNumber: 11
  },
  wallet: {
    show: true,
  },
  investor: {
    overview: {
      bonus: true,
    },
    settings: {
      hasInvestorProfiles: false,
    },
  },
  borrower_referral_email: {
    show: false,
    email: ''
  },
  intercom: {
    enable: true
  },
  google_tag_manager_id: 'GTM-KL3HMW',
  sendgrid_template: {
    investor_twoFa_email_template_id: '203d20e8-1fb0-4981-b5fd-07ae907c00b6',
    borrower_twoFa_email_template_id: '203d20e8-1fb0-4981-b5fd-07ae907c00b6',
    borrower_email_template_id: '44106b83-8d0d-4539-b9c7-0bce2f3ffe33',
    investor_email_template_id: 'e8ecb763-ef89-4f4c-85b9-ac791e901511'
  },
  referralLink: {
    borrower: window.location.origin + '/sign-up/borrower?referral=',
    investor: window.location.origin + '/sign-up/investor?referral='
  },
  blog: 'https://blog.modalku.co.id',
  learningCenter: 'http://blog.modalku.co.id/learning-center/',
  minimizingRiskArticle: '',
  maximizingInvestmentArticle: '',
  mediapress: 'https://blog.modalku.co.id/category/apa-kabar-modalku',
  inTheNews: '',
  facebook: 'https://www.facebook.com/modalkuid/',
  linkedin: 'https://www.linkedin.com/company/modalku',
  twitter: 'https://twitter.com/modalkuid',
  instagram: 'https://www.instagram.com/modalkuid',
  line: '',
  // Navigation configurations
  referProgram: false,
  digisign: {
    loan: false,
  },
  vidaEsign: true,
  marketingBanner: {
    showCovidCampaignBanner: false,
  },
  menu: {
    feedback: true
  },
  showPartner: false,
  showInvestorExposureBanner: false,
  showInvestorAccreditedDeclarationBanner: false,
  showAddBankAccount: false,
  showTaxInvoice: true,
  showPrivacyNoticeInvoiceFinancing: false,
  showPrivacyNoticeMalay: false,
  showPrivacyNotice: true,
  zoho_leads_owner: null,
  zoho_leads_owner_id: null,
  zoho_leads_source: null,
  wootricToken: 'NPS-44fd5589',
  showDisclosureNotice: false,
  enable2Fa: true,
  enable2FaLogin: false,
  zohoLeadsOwnerBorrow: [
    { id: '2747047000003599004', email: 'ali.afrijal@modalku.co.id' },
    { id: '2747047000007323014', email: 'sandy.christian@modalku.co.id' },
  ],
  leadAmountSetting: 500000000,
  infoEmail: 'layanan@modalku.co.id',
  learnMoreAALink: '',
  enableWootric: true,
  showLegalPopup: false,
  passportExpiredMonthLimit: 6,
  careerBambooHRLink: 'https://apply.workable.com/fundingsocieties/',
  enableRestructuredLoan: false,
  websiteTermsAndConditionPdf: '',
  subDistrictDetailEnabled: false,
  navigation: {
    loginDropDown: false,
    exposeSignUpMenu: false,
    blog: {
      show: false,
      link: ''
    },
    getFunding: {
      show: false,
      link: ''
    }
  },
  dateRestrictions: {
    passportExpiry: 6
  },
  modalPromoBanner: true,
  showFacilityLoan: true,
  showICNumberText: true,
  ecommercePageUrlBorrowPage: '',
  ecommerceApplyNowBorrowPage: 'https://modalku.co.id/sign-up-borrower',
  statistic: {
    showDefaultRate: false,
    mediaPressButton: {
      show: true
    }
  },
  autoInvestment: {
    enableAutoInvestment: false,
    borrowerExposure: {
      show: true
    },
    borrowerExposureWarning: {
      minimumValue: 10,
      show: true
    },
    enableInvestIslamicOnlyToggle: false,
  },
  signUp: {
    allowedOTpChannel: ['sms', 'email'],
    automatedPrefilHowDidYouFindUs: {
      enable: true,
      referral: false
    },
    maximumAddressCharacter: 40
  },
  twoFa: {
    verify: false
  },
  memberSetting: {
    agreement: {
      manualInjection: {
        show: false,
        link: ''
      }
    }
  },
  reverification: {
    show: true,
    riskDisclosure: false,
    suitabilityAssessment: false,
    hideLoanCards: false,
    eKYC: true,
  },
  withdrawal: {
    allowDecimalInput: false
  },
  footer: {
    appDownloadButton: {
      show: true
    },
    menu: {
      media: {
        show: true,
      },
      whoWeAre: {
        show: true,
        subMenu: {
          ourStory: false,
          statistics: true,
          careers: true,
          help: true,
        }
      }
    }
  },
  analytics: {
    SearchGuru: {
      investorSignUpSuccess: false
    }
  },
  showCreateNewLoanButton: false,
  showDashboardAgreementModal: true,
  showFSCInvestment: false,
  liveCaptureDocsForEKYC: {
    citizen: ['KTP', 'SELFIE'],
    foreigner: ['PASSPORT', 'SELFIE'],
  },
  enableEsignPerInvestment: true,
};

export default idConfiguration;
